import { DefaultState } from '@src/redux/types'

import * as actionTypes from '../../constants/level/actionTypes'
import { LEVEL_ALL } from '../../constants/level/api'

export const defaultState = () => ({ loading: false, error: null, data: null })

export const initialState: () => {
  [actionTypes.LEVEL_ALL]: DefaultState<`${typeof LEVEL_ALL}`, 'get'>
} = () => ({
  [actionTypes.LEVEL_ALL]: defaultState(),
})
